import React, { useContext, useEffect, useState } from 'react';
import TableCoinMutation from '../../components/TableCoinMutation';
import { useHistory, useParams } from "react-router-dom";
import axiosInstance from "../../config/axios";
import { useDebouncedCallback } from 'use-debounce';
import { RootContext } from '../../App';
import refactorStructureData from '../../helpers/refactorDataMenu';

export default function CoinMutation() {

  const history = useHistory();
  const [coinMutation, setCoinMutation] = useState([])
  const [pending, setPending] = useState(true);
  const [fromCreateAt, setFromCreateAt] = useState();
  const [toCreateAt, setToCreateAt] = useState();
  const { state, setState } = useContext(RootContext)

  const param = useParams();
  const AdminID = param.adminid;

  const debounced = useDebouncedCallback(

    (action) => {

      action()
    },
    200
  );

  const getData = () => {

    const token = localStorage.getItem("access_token");
    const group = JSON.parse(localStorage.getItem("group"))

    if (!token) {

      history.push("/login");
    } else {

      try {

        axiosInstance("get_coin_mutation", {
          method: "POST",
          data: {
            token: token,
            group: group.wbid,
            admin_id: AdminID,
            from_date: fromCreateAt,
            to_date: toCreateAt,
          },
        })
          .then((res) => {

            setState({
              ...state,
              group: res.data.data.additional_data.group,
              menu: refactorStructureData(res.data.data.additional_data.menu),
            });
            setCoinMutation(res.data.data.list)
            setPending(false);
          })
          .catch((err) => {

            localStorage.removeItem("access_token");
            history.push("/login");
          });
      } catch (error) {

        console.log("ERROR: ", error);
      }
    }
  };

  useEffect(() => {

    getData()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toCreateAt, fromCreateAt])

  return (
    <>
      <div className="bg-light-blue-500 pt-7 pb-28 px-3 md:px-8 h-auto">
      </div>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <TableCoinMutation title="Coin Mutation" tableData={coinMutation} pending={pending}

              fromCreateAtEvent={(event) => {
                debounced(() => setFromCreateAt(event.target.value))
              }}
              toCreateAtEvent={(event) => {
                debounced(() => setToCreateAt(event.target.value))
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
